// 1. React and fabric. 
import * as React from 'react';
// 2. Store and Types. 
// 3. Scripts. 
// 4. Components and Views. 
import DashboardEditor  from '../DashboardComponents/DashboardEditor';

interface IDashboardEditViewProps
{
	ID: string;
}

export default class DashboardEditView extends React.Component<IDashboardEditViewProps>
{
	constructor(props: IDashboardEditViewProps)
	{
		super(props);
	}

	componentDidCatch(error, info)
	{
		console.error((new Date()).toISOString() + ' ' + this.constructor.name + '.componentDidCatch', error, info);
	}

	public render()
	{
		return <DashboardEditor {...this.props} CATEGORY="Dashboard" />;
	}
}

